import type { FC } from '../../lib/teact/teact';
import { memo } from '../../lib/teact/teact';

import {
  RASITECH_ADMIN_URL,
  RASITECH_CHANNEL_URL,
  RASITECH_WELCOME_CHANNEL,
  RASITECH_ADMIN_USERNAME,
} from '../../rasitech/constants';
import { markWelcomeSeen } from '../../util/rasitechAccess';
import { openRasiTelegramLink } from '../../util/openRasiLink';

import useLastCallback from '../../hooks/useLastCallback';

import Button from '../ui/Button';
import Modal from '../ui/Modal';

type OwnProps = {
  isOpen: boolean;
  userId: string;
  onClose: () => void;
};

const RasiWelcomeModal: FC<OwnProps> = ({ isOpen, userId, onClose }) => {
  const handleJoin = useLastCallback(() => {
    openRasiTelegramLink(RASITECH_CHANNEL_URL);
    markWelcomeSeen(userId);
    onClose();
  });

  const handleContactAdmin = useLastCallback(() => {
    openRasiTelegramLink(RASITECH_ADMIN_URL);
  });

  const handleDismiss = useLastCallback(() => {
    markWelcomeSeen(userId);
    onClose();
  });

  return (
    <Modal
      isOpen={isOpen}
      className="rasi-welcome-modal"
      onClose={handleDismiss}
      title="Selamat datang di Nusantara Messager"
    >
      <p dir="auto">
        Bergabunglah ke channel komunitas
        {' '}
        <strong>@{RASITECH_WELCOME_CHANNEL}</strong>
        {' '}
        untuk update dan diskusi.
      </p>
      <p dir="auto">
        Butuh akses fitur berbayar atau bantuan? Hubungi admin
        {' '}
        <strong>@{RASITECH_ADMIN_USERNAME}</strong>
        .
      </p>
      <div className="dialog-buttons-column mt-2">
        <Button className="confirm-dialog-button" onClick={handleJoin} ripple>
          Gabung channel
        </Button>
        <Button className="confirm-dialog-button" isText onClick={handleContactAdmin}>
          Hubungi admin
        </Button>
        <Button className="confirm-dialog-button" isText onClick={handleDismiss}>
          Nanti
        </Button>
      </div>
    </Modal>
  );
};

export default memo(RasiWelcomeModal);
